export default function Menu(props) {
  const s = props?.size ?? 24;
  const c = props?.color ?? '#292D32';
  const stroke = props?.strokeWidth ?? 1.5;

  return (
    <svg
      width={s}
      height={s}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={props?.['aria-hidden']}
      focusable="false"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.4036 1.91434L14.406 1.91596L20.3914 5.84292C22.7628 7.39911 22.7628 10.8708 20.3915 12.427L14.402 16.3567V16.3567C13.7131 16.8095 12.8458 17.0125 12.02 17.0125C11.1945 17.0125 10.3278 16.8098 9.639 16.3574L9.638 16.3567L3.62001 12.428C1.23668 10.8721 1.23666 7.38795 3.62 5.83199L9.638 1.9033L9.63902 1.90263C10.3279 1.45013 11.1948 1.24731 12.0213 1.24875C12.8472 1.2502 13.7145 1.4558 14.4036 1.91434ZM12.0187 2.74875C11.4156 2.7477 10.853 2.89967 10.462 3.1567L10.46 3.15803L4.44 7.08802V7.08802C2.96335 8.05206 2.96334 10.2079 4.43999 11.172V11.172L10.462 15.1033C10.853 15.3604 11.4159 15.5125 12.02 15.5125C12.6241 15.5125 13.187 15.3604 13.578 15.1033L19.5685 11.173V11.173C21.0371 10.2092 21.0371 8.06089 19.5686 7.09708V7.09708L13.574 3.16406C13.1835 2.90373 12.6218 2.7498 12.0187 2.74875Z"
        fill={c}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.6316 12.33C6.04581 12.3309 6.38088 12.6674 6.38 13.0816L6.37 17.77V17.77C6.37019 18.219 6.54752 18.7269 6.8687 19.1731C7.19007 19.6196 7.61394 19.9473 8.0369 20.0884V20.0884L11.2233 21.1472L11.2246 21.1476C11.4001 21.2048 11.6796 21.245 11.9962 21.245C12.3113 21.245 12.5944 21.2052 12.7775 21.1469L15.9628 20.0885V20.0885C16.3858 19.9474 16.8099 19.6196 17.1313 19.1731C17.4527 18.7267 17.63 18.2192 17.63 17.77V13.13C17.63 12.7158 17.9658 12.38 18.38 12.38C18.7942 12.38 19.13 12.7158 19.13 13.13V17.77C19.13 18.5908 18.8173 19.3983 18.3487 20.0494C17.8801 20.7004 17.2141 21.2525 16.4372 21.5115L13.2395 22.5741C12.8624 22.6953 12.412 22.745 11.9962 22.745C11.5812 22.745 11.1313 22.6954 10.7567 22.5728L10.7535 22.5717L7.5635 21.5117C6.78655 21.2528 6.11986 20.7004 5.65129 20.0494C5.18265 19.3983 4.87 18.5908 4.87 17.77L4.87 17.7684L4.88 13.0784C4.88088 12.6642 5.21738 12.3291 5.6316 12.33Z"
        fill={c}
      />
    </svg>
  );
}
